<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { createRealEstateBrokerCommissionPresenter } from '../composables/realEstateBrokerCommissionPresenter';

defineProps({
  installments: { type: Array, default: () => [] },
});

const emit = defineEmits(['open']);
const { t } = useI18n();
const { date, money, statusLabel } =
  createRealEstateBrokerCommissionPresenter(t);
const statusDetail = row => ({ status: row.status });
</script>

<template>
  <LaisCard
    :title="t('REAL_ESTATE_BROKER_COMMISSION.INSTALLMENTS.TITLE')"
    density="flush"
  >
    <p v-if="!installments.length" class="p-5 text-sm text-lais-text-muted">
      {{ t('REAL_ESTATE_BROKER_COMMISSION.INSTALLMENTS.EMPTY') }}
    </p>
    <div v-else class="divide-y divide-lais-border-soft">
      <button
        v-for="installment in installments"
        :key="installment.id"
        type="button"
        class="grid w-full gap-2 px-5 py-4 text-left transition hover:bg-lais-bg-soft sm:grid-cols-[minmax(0,1fr)_auto_auto] sm:items-center sm:gap-4"
        @click="emit('open', installment.id)"
      >
        <span class="min-w-0">
          <span class="block font-semibold text-lais-text">
            {{
              t('REAL_ESTATE_BROKER_COMMISSION.TABLE.INSTALLMENT', {
                current: installment.numero,
                total: installment.total,
              })
            }}
          </span>
          <span class="mt-1 block text-xs text-lais-text-muted">{{
            date(installment.previsao_pagamento)
          }}</span>
        </span>
        <span
          class="w-fit rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-body"
        >
          {{ statusLabel(statusDetail(installment)) }}
        </span>
        <span class="font-semibold text-lais-text">{{
          money(installment.valor)
        }}</span>
      </button>
    </div>
  </LaisCard>
</template>
